import trim from '../helpers/trim';

const EMPTY_STR = '';
const NON_NUMBER_PAT = /\D/g;

const formatPhoneStr = (phone) => {
  if (phone && phone.match(/^\+7/)) {
    switch (phone.length) {
      case 3:
      case 4:
      case 5:
        return phone.replace(/^\+7(\d*)$/, '+7 ($1');
      case 6:
      case 7:
      case 8:
        return phone.replace(/^\+7(\d{3})(\d*)$/, '+7 ($1) $2');
      case 9:
      case 10:
        return phone.replace(/^\+7(\d{3})(\d{3})(\d*)$/, '+7 ($1) $2-$3');
      default:
        return phone.replace(/^\+7(\d{3})(\d{3})(\d{2})(\d*)$/, '+7 ($1) $2-$3-$4');
    }
  }

  return phone;
};

export const formatPhoneNumber = (v) => {
  let value = v ? v.replace(NON_NUMBER_PAT, EMPTY_STR) : v;
  value = trim(value);
  if (value && value.substr(0, 1) !== '+') {
    value = `+${value}`;
  }

  return value;
};

export const formatPhoneNumber2 = (v) => {
  let value = v ? v.replace(NON_NUMBER_PAT, EMPTY_STR) : v;
  value = trim(value);
  if (value !== undefined && value.substr(0, 1) !== '+') {
    value = `+${value}`;
  }

  return formatPhoneStr(value);
};
